import withNumberFormat from "../hoc/withNumberFormat";

export default withNumberFormat({
  thousandSeparator: true
});
